var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pageRoot" }, [
      _c("h1", [_vm._v("TdsAppService Administration Homepage")]),
      _vm._v(" "),
      _c("p", [_vm._v("Please select a menu item above.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }